import { Star } from "lucide-react";

export function Stars({ value = 0, size = 16, className = "", showValue = false }) {
  const rounded = Math.round(value * 2) / 2;
  return (
    <span className={`inline-flex items-baseline gap-1 ${className}`}>
      <span className="inline-flex text-gold" aria-label={`${value} out of 5`}>
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            size={size}
            strokeWidth={1.2}
            className={i <= rounded ? "fill-current" : "opacity-25"}
          />
        ))}
      </span>
      {showValue && value > 0 && (
        <span className="font-serif text-espresso" style={{ fontSize: size + 2 }}>{value}</span>
      )}
    </span>
  );
}

export function StarPicker({ value, onChange, size = 44 }) {
  return (
    <div className="inline-flex gap-2" role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(i)}
          data-testid={`star-${i}`}
          aria-label={`${i} star${i === 1 ? "" : "s"}`}
          className="p-1 rounded-full hover:scale-110 transition-transform focus:outline-none focus:ring-2 focus:ring-gold/50"
        >
          <Star
            size={size}
            strokeWidth={1.2}
            className={i <= value ? "fill-gold text-gold" : "text-espresso-light/40"}
          />
        </button>
      ))}
    </div>
  );
}
